import {action} from 'mobx';

import {EXPIRE_TIME, EXPIRES_IN, EXPIRES_PENDING} from '../../../constants/storeConstants';
import {STATE_PENDING, STATE_FULFILLED, STATE_REJECTED} from '../../../constants/asyncConstants';
import serverApi from '../../../utils/serverApi';
import ApiMapBaseStore from '../common/apiMapBaseStore';

/**
 * ApiUserGetOneStore
 */
class ApiUserGetOneStore extends ApiMapBaseStore {
  /**
   * Fetches user information from the server.
   *
   * @param {string} userId
   */
  @action makeRequest(userId) {
    const safeUserId = String(userId);

    this.dataMap.set(safeUserId, {
      state: STATE_PENDING,
      [EXPIRE_TIME]: Date.now() + EXPIRES_PENDING,
      data: null,
      error: null,
    });

    serverApi.userGetOneById(safeUserId).then(
      action('userGetOneSuccess', (foundUser) => {
        this.dataMap.set(safeUserId, {
          state: STATE_FULFILLED,
          [EXPIRE_TIME]: Date.now() + EXPIRES_IN,
          data: foundUser,
          error: null,
        });
      }),
      action('userGetOneError', (userGetOneError) => {
        this.dataMap.set(safeUserId, {
          state: STATE_REJECTED,
          [EXPIRE_TIME]: null,
          data: null,
          error: userGetOneError,
        });
      })
    );
  }
}

export default new ApiUserGetOneStore();
